/**
 * Tento soubor slouží jako workaround pro zprovoznění importů z 'redux-saga-test-plan/matchers'. Při tomto importu ale testy nejsou schopny
 * získat požadovaný objekt.
 *
 * Tento balíček společně s nastavením aliasů v jest.config.json umožňuje přesměrovat importy, takže v testech aplikace můžeme
 * importovat matchers klasickým způsobem, který odpovídá typingům a bez použití ts-ignore.
 */

// @ts-ignore
import {matchers as originalMatchers} from "redux-saga-test-plan";

const matchers = {
    actionChannel: originalMatchers.actionChannel,
    apply: originalMatchers.apply,
    call: originalMatchers.call,
    cancel: originalMatchers.cancel,
    cancelled: originalMatchers.cancelled,
    cps: originalMatchers.cps,
    flush: originalMatchers.flush,
    fork: originalMatchers.fork,
    getContext: originalMatchers.getContext,
    join: originalMatchers.join,
    put: originalMatchers.put,
    race: originalMatchers.race,
    select: originalMatchers.select,
    setContext: originalMatchers.setContext,
    spawn: originalMatchers.spawn,
    take: originalMatchers.take,
};

export default matchers;
